/* eslint-disable indent */
import React, { useEffect, useState } from 'react';
import './index.scss';
import CollectMapApi from '@/fetch/bussiness/collectMap';
import { HttpStatusCode } from '@/fetch/core/constant';
import { Button, Cascader, Flex, Input, message, Modal, Table } from 'antd';
import { columns } from './utils';
import { TaskStatusEnum, TaskStatusTextMap } from '@/utils/constant';
import { LatLon, TaskDetail } from '@/utils/type';
import CollectRouteMap from '../CollectRouteMap';
import * as turf from '@turf/turf';
import { isEmpty } from '@/utils/util';
import { showModal } from '../Modal';
interface Props {
  cockpitNumber: string;
  vehicleName?: string;
  setVisible: AnyFunc;
  visible: boolean;
}
const fetchApi = new CollectMapApi();
const CollectTaskModal = (props: Props) => {
  const { cockpitNumber, vehicleName, visible, setVisible } = props;
  const [mapVisible, setMapVisible] = useState(false);
  const [taskList, setTaskLit] = useState<any[]>([]);
  const [taskDetail, setTaskDetail] = useState<TaskDetail | null>(null);
  const [stationOptions, setStationOptions] = useState<any[]>([]);
  const [centerMark, setCenterMark] = useState<LatLon>({
    latitude: 34.53506,
    longitude: 108.93885,
  });
  const initSearchCondition = {
    searchForm: {
      stationId: null,
      taskName: '',
      stationInfo: [],
    },
    pageNum: 1,
    pageSize: 10,
  };
  const [searchCondition, setSearchCondition] = useState(initSearchCondition);

  const [total, setTotal] = useState(0);
  const getTaskList = async (searchCondition: any, vehicleName: any) => {
    try {
      const res = await fetchApi.getExplorationTaskList({
        ...searchCondition.searchForm,
        pageNum: searchCondition.pageNum,
        pageSize: searchCondition.pageSize,
        vehicleName,
      });
      if (res.code === HttpStatusCode.Success) {
        setTaskLit(res.data.list);
        setTotal(res.data.total);
      }
    } catch (err) {
      console.error(err);
    }
  };
  const transformStationData = (data: any[]) => {
    return data.map((item) => ({
      id: item.id,
      name: item.name,
      child: item.child?.map((subItem: any) => ({
        id: subItem.id,
        name: subItem.name,
      })),
    }));
  };
  const getUserStations = async () => {
    const res = await fetchApi.getUserStations();
    if (res.code === HttpStatusCode.Success) {
      setStationOptions(transformStationData(res.data));
    } else {
      setStationOptions([]);
    }
  };
  const associateTask = async (
    taskId: number,
    action: number,
    vehicleName: string
  ) => {
    try {
      const res = await fetchApi.associateTask({
        cockpitNumber,
        taskId,
        action,
        vehicleName,
      });
      if (res.code === HttpStatusCode.Success) {
        getTaskList(searchCondition, vehicleName);
      } else {
        message.error(res.message || '操作失败');
      }
    } catch (err) {
      console.error(err);
    }
  };

  const getExplorationTaskDetail = async (taskId: number) => {
    try {
      const res = await fetchApi.getExplorationTaskDetail(taskId);
      if (res.code === HttpStatusCode.Success) {
        setTaskDetail(res.data);
        if (res.data.taskRouteList && !isEmpty(res.data.taskRouteList)) {
          const coordinates = res.data?.taskRouteList.map((item: any) => [
            item.longitude,
            item.latitude,
          ]);
          const features = turf.points(coordinates);
          setCenterMark({
            latitude: turf.center(features).geometry.coordinates[1],
            longitude: turf.center(features).geometry.coordinates[0],
          });
        }
      } else {
        message.error(res.message || '操作失败');
        setTaskDetail(null);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const formatColumns = () => {
    return columns.map((col: any) => {
      switch (col.dataIndex) {
        case 'index':
          return {
            ...col,
            render: (text: any, record: any, index: number) => {
              return <>{index + 1}</>;
            },
          };
        case 'duration':
          return {
            ...col,
            render: (text: any, record: any, index: number) => {
              const now = Date.now();
              const diff = now - record.taskSubmitTime;

              const hours = Math.floor(diff / (1000 * 60 * 60));
              const minutes = Math.floor(
                (diff % (1000 * 60 * 60)) / (1000 * 60)
              );

              let formattedDuration = '';
              if (hours > 0) {
                formattedDuration += `${hours}小时`;
              }
              if (minutes > 0 || hours === 0) {
                formattedDuration += `${minutes}分钟`;
              }

              return formattedDuration;
            },
          };
        case 'taskStatus':
          return {
            ...col,
            render: (text: any, record: any, index: number) => {
              return <>{TaskStatusTextMap.get(record.taskStatus)}</>;
            },
          };
        case 'operation':
          return {
            ...col,
            render: (text: any, record: any, index: number) => {
              switch (record.taskStatus) {
                case TaskStatusEnum.COLLECTING:
                  return (
                    <div className="ops-btns">
                      <a
                        className="btn"
                        onClick={() => {
                          getExplorationTaskDetail(record.taskId);
                          setMapVisible(true);
                        }}
                      >
                        详情
                      </a>
                      {vehicleName && (
                        <a
                          className="btn"
                          onClick={() => {
                            showModal({
                              title: '取消认领',
                              content:
                                '确认取消认领将导致本次任务中所有采集的数据被清空，是否继续取消？',
                              width: 1000,
                              footer: {
                                showOk: true,
                                showCancel: true,
                                cancelText: '取消',
                                okText: '确认',
                                cancelFunc: (cb) => cb(),
                                okFunc: (cb) => {
                                  associateTask(record.taskId, 0, vehicleName);
                                  cb();
                                },
                              },
                            });
                          }}
                        >
                          取消认领
                        </a>
                      )}
                    </div>
                  );
                case TaskStatusEnum.PENDING_CLAIM:
                  return (
                    <div className="ops-btns">
                      <a
                        className="btn"
                        onClick={() => {
                          getExplorationTaskDetail(record.taskId);
                          setMapVisible(true);
                        }}
                      >
                        详情
                      </a>
                      {!taskList?.find(
                        (task: any) =>
                          task.taskStatus === TaskStatusEnum.COLLECTING
                      ) &&
                        vehicleName && (
                          <a
                            className="btn"
                            onClick={() => {
                              associateTask(record.taskId, 1, vehicleName);
                            }}
                          >
                            认领
                          </a>
                        )}
                    </div>
                  );
              }
            },
          };
        default:
          return col;
      }
    });
  };

  useEffect(() => {
    if (visible) {
      if (!mapVisible) {
        getTaskList(searchCondition, vehicleName);
        getUserStations();
      }
    }
    return () => {
      setTaskDetail(null);
      setStationOptions([]);
      setTaskLit([]);
    };
  }, [visible, mapVisible]);
  const onSearchClick = () => {
    getTaskList(searchCondition, vehicleName);
  };
  const onResetClick = () => {
    setSearchCondition({ ...initSearchCondition });
    getTaskList({ ...initSearchCondition }, vehicleName);
  };

  return (
    <>
      <Modal
        destroyOnClose
        width={2000}
        styles={{
          body: { height: '1000px' },
        }}
        open={visible}
        onCancel={() => {
          setVisible(false);
          setSearchCondition({ ...initSearchCondition });
        }}
        keyboard={false}
        closable
        title="采集线路"
        footer={
          <div className="footer">
            <span className="total">共 {taskList?.length} 条待采路线</span>
            <Button
              type="default"
              onClick={() => {
                setVisible(false);
                setSearchCondition({ ...initSearchCondition });
              }}
            >
              关闭
            </Button>
          </div>
        }
      >
        <Flex className="search-form" justify="space-between">
          <Flex gap={50}>
            <div className="select-container">
              <div>所属站点</div>
              <Cascader
                allowClear
                placeholder="请选择站点"
                options={stationOptions}
                fieldNames={{
                  label: 'name',
                  value: 'id',
                  children: 'child',
                }}
                showSearch
                onClear={() => {
                  setSearchCondition({
                    ...searchCondition,
                    searchForm: {
                      ...searchCondition.searchForm,
                      stationId: null,
                      stationInfo: [],
                    },
                  });
                }}
                value={searchCondition.searchForm.stationInfo}
                onChange={(values) => {
                  setSearchCondition({
                    ...searchCondition,
                    searchForm: {
                      ...searchCondition.searchForm,
                      stationId: values[1],
                      stationInfo: values,
                    },
                  });
                }}
                getPopupContainer={(triggerNode) => triggerNode.parentElement}
              />
            </div>
            <div className="select-container">
              <div>任务名称</div>
              <Input
                placeholder="请输入任务名称"
                value={searchCondition.searchForm.taskName}
                onChange={(e) => {
                  setSearchCondition({
                    ...searchCondition,
                    searchForm: {
                      ...searchCondition.searchForm,
                      taskName: e.target.value,
                    },
                  });
                }}
              />
            </div>
          </Flex>
          <div className="btn-container">
            <Button className="reset-btn" onClick={onResetClick}>
              重置
            </Button>
            <Button type="primary" onClick={onSearchClick}>
              查询
            </Button>
          </div>
        </Flex>
        <Table
          dataSource={taskList}
          columns={formatColumns()}
          pagination={{
            pageSize: searchCondition.pageSize,
            current: searchCondition.pageNum,
            total: total,
            showSizeChanger: false,
            showQuickJumper: false,
            onChange(page, pageSize) {
              setSearchCondition({
                ...searchCondition,
                pageNum: page,
                pageSize,
              });
              getTaskList(
                {
                  ...searchCondition,
                  pageNum: page,
                  pageSize,
                },
                vehicleName
              );
            },
          }}
          scroll={{ x: 1000, y: 800 }}
          rowKey="taskId"
        />
      </Modal>
      <Modal
        destroyOnClose
        width={2000}
        styles={{
          body: { height: '1050px' },
        }}
        open={mapVisible}
        onCancel={() => {
          setMapVisible(false);
        }}
        keyboard={false}
        closable
        title={taskDetail?.taskName}
        footer={null}
      >
        <CollectRouteMap
          centerMark={centerMark}
          taskRouteList={taskDetail?.taskRouteList}
          fourLaneIndexList={taskDetail?.fourLaneList}
          id={'collect-map-box-modal'}
        />
      </Modal>
    </>
  );
};
export default React.memo(CollectTaskModal);
